var isProd = true;
const httpClient = {
    baseURL: isProd ? 'https://prd9.fieldprofsm.com/fp_gateway/' : 'https://dev9.fieldprofsm.com/fp_gateway/',
    debugTool:true
};
export default httpClient;
